import React, { forwardRef } from 'react';
import FilterIcon from '../../icons/FilterIcon';
import Button from '../button/Button';

const FilterButton = forwardRef(({ onClick, isLoading = false }, ref) => {
  return (
    <Button
      testId='btn-filter'
      ref={ref}
      icon={<FilterIcon />}
      variant='ghost'
      className='!px-[20px] !py-[9px]'
      onClickHandler={onClick}
      disabled={isLoading}
    />
  );
});

FilterButton.displayName = 'FilterButton';

export default FilterButton;
